import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Routes, buildRoute } from 'react-scale/components/ExpertManagement/urls';
import { OptionsMenu } from '@scale/scaleui';
import { WORKER_MANAGER } from 'react-scale/components/ExpertManagement/constants';
import { getViewMenuItems } from 'react-scale/corp/views/CorpProjectGroupManager/components/layout';

export function WorkerManagerDashboardHeader({ action }: { action?: ReactNode }) {
  const menuItems = getViewMenuItems({ view: WORKER_MANAGER });

  return (
    <div className="flex flex-row items-center justify-between p-4 w-full">
      <Link to={buildRoute(Routes.ExpertManagement)}>
        <div className="flex flex-row items-center">
          <div className="relative w-7 h-7 rounded-md bg-primary-900">
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              <FontAwesomeIcon
                icon="atom-alt"
                className="text-neutral-100"
                style={{ fontSize: 20, transform: 'rotate(45deg)' }}
              />
            </div>
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              <FontAwesomeIcon
                icon="atom-alt"
                className="text-primary-300"
                style={{ fontSize: 20 }}
              />
            </div>
          </div>
          <div className="text-xl ml-2 font-bold text-neutral-600"> {WORKER_MANAGER} </div>
        </div>
      </Link>
      <OptionsMenu
        buttonIcon="ellipsis-h"
        className=""
        direction="bottom-right"
        icon="ellipsis-h"
        iconSize="sm"
        iconVariant="neutral"
        menuItems={menuItems}
        size="lg"
        variant="neutral"
      />
      {action}
    </div>
  );
}
